import { Injectable } from "@angular/core";
import { RequestActivityRecordtDto } from "../dto/activity-report.dto";
import { NestApiProvider } from "../../nest-api";
import { ResponseDeleteDepartmentByDto } from "../dto/department.dto";

@Injectable()
export class ActivityReportApi {
  private service: string = '';
  private model: string = 'ActivityReport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {

  }

  preview() {


  }

  downloadExcel(data: RequestActivityRecordtDto) {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: RequestActivityRecordtDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  downloadPdf(data: RequestActivityRecordtDto) {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: RequestActivityRecordtDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }


  reportSendEmailExcel(data: RequestActivityRecordtDto) {
    const method: string = 'POST';
    const func: string = 'reportSendEmailExcel';
    const params: RequestActivityRecordtDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDepartmentByDto>(method, url, params, urlParams, body);
  }

  reportSendEmailPdf(data: RequestActivityRecordtDto) {
    const method: string = 'POST';
    const func: string = 'reportSendEmailPdf';
    const params: RequestActivityRecordtDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDepartmentByDto>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/activity-report.api.ts